import type { GetServerSideProps, NextPage } from 'next';

import { API_URL } from '@env';
import Head from 'next/head';
import Layout from '@components/template/MainLayout';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import WelcomeSection from '@components/organism/WelcomeSection';
import { getInitialListeningWelcomeState } from 'store/listening/reducer';
import router from 'next/router';
import { ListeningWelcomeProps } from '@models/listening';

const MODULE_NAME = 'listening';
const API_LISTENING_WELCOME_PATH = `/${MODULE_NAME}/welcome`;
const LISTENING_PATH = `/${MODULE_NAME}/tasks`;
const TITLE = 'Platzi IELTS Listening Playground';

const ListeningPage: NextPage<ListeningWelcomeProps> = ({ data }) => {
  const { welcomeData } = data;

  const state = getInitialListeningWelcomeState();

  return (
    <>
      <Head>
        <title>{TITLE}</title>
      </Head>
      <Layout
        progress={state.progressValue}
        isProgressBarVisible={state.isProgressBarVisible}
        isNextButtonVisible={state.isNextButtonVisible}
        onNext={() => router.push(LISTENING_PATH)}
      >
        <WelcomeSection data={welcomeData} />
      </Layout>
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
  const data = await (await fetch(`${API_URL}${API_LISTENING_WELCOME_PATH}`)).json();
  return {
    props: {
      data,
      ...(await serverSideTranslations(locale || 'en', ['common'])),
    },
  };
};

export default ListeningPage;
